import React, { Component } from 'react';
import { Col, Label, Card, CardBody, Button, TabContent, TabPane, Nav, NavItem, NavLink, Row, FormGroup, Form, Input } from 'reactstrap';
import { fetchPartnerOrdersRequest } from './action'
import { getCorporateName } from '../../Analyst/Cases/List/Actions';
import { connect } from 'react-redux';
import {
    getPageDescriptionBody,
    setRequestBody,
    setAppliedFilters,
    createFilterUrl,
    getUrlFilter
} from './helper'
import {
    deleteEntityFilter,
    deleteAppliedFilters
} from '../../Analyst/Cases/List/Helper'
import IntlDashboardTable from './Table';
import FilterFormTypeOne from '../../components/ReusableComponents/FilterFormTypeOne/index'

class InternationalDashboard extends Component {
    constructor(props) {
        super(props);
        this.formOneElement = React.createRef();
        this.tableElement = React.createRef();
        this.state = {
            partnerOrders: [],
            noOfPages: 0,
            loading: true,
            popoverOpen: false,
            updateFlag: false,
            toDate: null,
            fromDate: null,
            searchText: '',
            searchCorporate: [],
            appliedFilters: [],
            productType: undefined,
            statusType: undefined,
            country: undefined,
            sorted: {
                id: "requestDate",
                desc: true,
              }
        };
    }

    componentDidMount = () => {
        this.props.getCorporateName();
        if (this.props.partnerOrders.data.length == 0) {
            this.onFetchPage(0, 10, { id: "requestDate", desc: true });
        }
        this.props.history.push(this.props.location);

        const urlFilters = getUrlFilter(this.props.location.search);
        if (urlFilters) {
            let date = {
                toDate: urlFilters.toDate,
                fromDate: urlFilters.fromDate
            }
            this.orderListFilterCallBack(urlFilters.productType, urlFilters.statusType, urlFilters.country, urlFilters.selectedCorporates, date, false, false);            
        }
    }

    onFetchPage = (skip, limit, sorted) => {
       if(this.state.sorted.id !== sorted.id || this.state.sorted.desc !== sorted.desc){
        this.tableElement.current.resetPagination();
        skip = 0;
       }
        this.setState({
            loading: true,
            sorted: sorted
        });
        const tempPageDescription = getPageDescriptionBody({ skip, limit, sorted });
        const date = {
            toDate: this.state.toDate,
            fromDate: this.state.fromDate
        }
        const tempRequestBody = setRequestBody(this.state.productType, this.state.statusType, this.state.country, this.state.searchCorporate, date, this.state.searchText)
        this.props.fetchPartnerOrdersRequest(tempPageDescription, tempRequestBody);
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.partnerOrders !== this.props.partnerOrders) {
            this.setState({
                partnerOrders: this.props.partnerOrders.data,
                noOfPages: this.props.partnerOrders.noOfPages,
                loading: false
            });
        }
    }
    popovertoggle = () => {
        this.setState((prevState) => ({
            popoverOpen: !prevState.popoverOpen
        }));
        this.formOneElement.current.handleFilterOnPageRefreshOrBackButton(getUrlFilter(this.props.location.search));        
    }
    orderListFilterCallBack = (productType, statusType, country, data, date, popoverFlag, filterResetFlag) => {
        const tempAppliedFilters = setAppliedFilters(productType, statusType, country, data, date);
        this.setState({
            toDate: date.toDate,
            fromDate: date.fromDate,
            productType: productType,
            statusType: statusType,
            country: country,
            searchCorporate: data,
            updateFlag: true,
            loading: true,
            appliedFilters: tempAppliedFilters,
            clearAllButton: (tempAppliedFilters.length > 0) ? <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button> : null,
        });

        const tempPageDescription = getPageDescriptionBody({
            skip: 0,
            limit: 10,
            sorted: {
                desc: true,
                id: "requestDate"
            }
        });
        const requestBody = setRequestBody(productType, statusType, country, data, date, this.state.searchText);
        this.props.fetchPartnerOrdersRequest(tempPageDescription, requestBody);

        if (popoverFlag && !filterResetFlag) {
            const url = createFilterUrl(productType, statusType, country, date, data);
            this.props.history.push(`?${url}`);
            this.popovertoggle();
        } else if (popoverFlag && filterResetFlag) {
            this.props.history.push(`?${""}`);
        }
        this.tableElement.current.resetPagination();
    }

    handleRemoveFilter = (removeFilter) => {
        let clearButton, toDate = this.state.toDate, fromDate = this.state.fromDate, removeEntityFilterList = [...this.state.searchCorporate];
        const removeFilterList = deleteAppliedFilters(removeFilter, this.state.appliedFilters);
        if (removeFilterList.length > 0) {
            clearButton = <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button>
        } else {
            clearButton = null
        }
        if (removeFilter.value === 'date') {
            fromDate = null
            toDate = null
        } else {
            removeEntityFilterList = deleteEntityFilter(this.state.searchCorporate, removeFilter);
            toDate = this.state.toDate
            fromDate = this.state.fromDate
        }
        this.setState({
            appliedFilters: removeFilterList,
            clearAllButton: clearButton,
            searchCorporate: removeEntityFilterList,
            fromDate: fromDate,
            toDate: toDate,
            loading: true
        });
        const tempPageDescription = getPageDescriptionBody({
            skip: 0,
            limit: 10,
            sorted: {
                desc: true,
                id: "requestDate"
            }
        });

        const date = {
            toDate: toDate,
            fromDate: fromDate,
        }
        if (removeFilter.value === 'productType') {
            this.setState({
                productType : undefined
            });
        }
        if (removeFilter.value === 'statusType') {
            this.setState({
                statusType : undefined
            });
        }
        if (removeFilter.value === 'country') {
            this.setState({
                country : undefined
            });
        }
        const tempRequestBody = setRequestBody(this.state.productType, this.state.statusType, this.state.country, removeEntityFilterList, date, this.state.searchText)
        this.props.fetchPartnerOrdersRequest(tempPageDescription, tempRequestBody)

        const url = createFilterUrl(this.state.productType, this.state.statusType, this.state.country, date, removeEntityFilterList);
        this.props.history.push(`?${url}`);

        this.formOneElement.current.handleRemoveFilter(removeFilter); // Removes item from popover filter
        this.tableElement.current.resetPagination();       
    }

    handleClearAll = () => {
        this.onFetchPage(0, 10, { id: "requestDate", desc: true });
        this.formOneElement.current.handleResetDateFilter(); // Reset popover filter
        this.tableElement.current.resetPagination();        
    }

    handleSearchChange = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            // this.props.preloading(true)
            const tempPageDescription = getPageDescriptionBody({
                skip: 0,
                limit: 10,
                sorted: {
                    desc: true,
                    id: "requestDate"
                }
            });
            const date = {
                toDate: this.state.toDate,
                fromDate: this.state.fromDate
            }
            const requestBody = setRequestBody(this.state.productType, this.state.statusType, this.state.country, this.state.searchCorporate, date, event.target.value);
            this.props.fetchPartnerOrdersRequest(tempPageDescription, requestBody);
            this.setState({
                loading: true,
                searchText: event.target.value
            })
        }
        this.tableElement.current.resetPagination();    
    }

    render() {
        return (
            <Col>
                <Card>
                    <CardBody>
                        <Row className="search-case">
                            <Col sm='12'>
                                <Form className="form-search">
                                    <FormGroup className="mb-0 input-search">
                                        <i className="icon-search position-absolute"></i>
                                        <Input className="bg-light" type="search" name="search" id="search" onKeyPress={this.handleSearchChange} placeholder="Search by Case Name or Order Number" autoComplete="off" />
                                    </FormGroup>
                                </Form>
                            </Col>

                            <Col sm='2'>
                                <div className="filter-wrapper ml-auto">
                                    <div>
                                        <Button id="Popover1" className={this.state.popoverOpen ? 'btn-filter btn-icon filter-popover-open' : 'btn-filter btn-icon'} outline size="sm" color="primary" onClick={this.popovertoggle}>
                                            <i className="icon-filter"></i>
                                        </Button>
                                        {/*<Button color="primary" outline size="sm" className="ml-3 d-sm-none">Applied Filters</Button>*/}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <div className={this.state.popoverOpen ? "position-absolute filter-popover case-filter-popover d-block bg-light p-4" : "position-absolute filter-popover d-none p-3"}>
                            <FilterFormTypeOne
                                updateFlag={this.state.updateFlag}
                                multiselectTitle='Corporate Name'
                                correspondentList={this.props.corporateNameList}
                                dateFilterType='Requested On'
                                hideFilterCallback={this.popovertoggle}
                                filterCallback={this.orderListFilterCallBack}
                                dateFilters={{ toDate: this.state.toDate, fromDate: this.state.fromDate }}
                                selectedEntity={this.state.searchCorporate}
                                productTypeFlag={true}
                                statusTypeFlag={true}
                                countryFlag={true}
                                ref={this.formOneElement} />
                        </div>
                        <div className="row no-gutters mb-3 d-flex flex-column flex-sm-row">
                            <Label className={this.state.appliedFilters.length > 0 ? "filter-title col-sm-3 pr-0" : 'hidden'}>Applied Filters :</Label>
                            <div className="col-sm-21 pl-0 filter d-flex flex-wrap align-items-center">
                                {this.state.appliedFilters.map(p => {
                                    return (
                                        <span key={p.value} className="filter-item d-flex align-items-center mr-2 mb-2">
                                            {p.label} <i className="icon-close" onClick={() => this.handleRemoveFilter(p)}></i>
                                        </span>
                                    )
                                })}
                                {this.state.clearAllButton}
                            </div>
                        </div>
                    </CardBody>
                </Card>

                <Row>
                    <div className="col">
                        <IntlDashboardTable
                            tasks={this.state.partnerOrders}
                            noOfPages={this.state.noOfPages}
                            loading={this.state.loading}
                            onFetchPage={this.onFetchPage}
                            ref={this.tableElement} />
                    </div>
                </Row>
            </Col>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    partnerOrders: state.intl.partnerOrders,
    corporateNameList: state.cases.corporateNameList,
});

const mapDispatchToProps = (dispatch) => ({
    fetchPartnerOrdersRequest: (pageDescription, requestBody) => { dispatch(fetchPartnerOrdersRequest({ pageDescription, requestBody })); },
    getCorporateName: () => { dispatch(getCorporateName()) },
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InternationalDashboard);